'use strict';

const processInclude = require('base/util');

$(window).on('load', function () {
    processInclude(require('./storeApp/storeApp'));
    processInclude(require('./storeApp/easyFormValidation'));
    processInclude(require('./storeApp/initializeQrCode'));
});

